const componentStyles = (theme) => ({
  containerRoot: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: "39px",
      paddingRight: "39px",
    },
  },
  cardRoot: {
    marginTop: "2rem",
    backgroundColor: theme.palette.secondary.main,
  },
  cardActionsRoot: {
    backgroundColor: theme.palette.secondary.main + "!important",
  },
  buttonCancel: {
    color: theme.palette.white.main,
    backgroundColor: theme.palette.error.main,
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
});

export default componentStyles;